jQuery  (
        function()
            {
            $(document).ajaxSuccess (
                                    function(event, jqxhr, settings)
                                        {
                                        var responseJSON = jqxhr.responseJSON;                                
                                                                
                                        if(responseJSON)
                                            {
                                            if(responseJSON.messages)
                                                {
                                                $.each  (
                                                        responseJSON.messages,
                                                        function(type, groups)
                                                            { 
                                                            groups = (typeof(groups) === 'object') ? groups : [groups];

                                                            $.each  (
                                                                    groups,
                                                                    function(group, messages)
                                                                        {     
                                                                        var title = group;
                                                                        var content = '';
                                                                                                                                                                                                                            
                                                                        if(typeof(messages) === 'object')
                                                                            {
                                                                            ulStyle = (messages.length > 1) ? 'm-0 p-0 pl-3'    : 'm-0 p-0 list-unstyled';
                                                                            liStyle = (messages.length > 1) ? 'p-1 pb-0'        : 'p-1 pb-0';

                                                                            content += '<ul class="' + ulStyle + '">';

                                                                            $.each  (
                                                                                    messages,
                                                                                    function(i, message)
                                                                                        {
                                                                                        content += '<li class="' + liStyle + '">' + message + '</li>';
                                                                                        }
                                                                                    ); 

                                                                            content += '</ul>'; 
                                                                            }                                                                            
                                                                            else    {
                                                                                    content += messages;
                                                                                    }
                                                                        
                                                                        if(isNaN(title))
                                                                            {
                                                                            showToast(type, title, subTitle = null, content);
                                                                            }
                                                                            else    {
                                                                                    showSnack(type, content);
                                                                                    }
                                                                        }
                                                                    );
                                                            }
                                                        );
                                                }
                                            }

                                        return;
                                        }
                                    );
            

                                    
            $(document).ajaxError   (
                                    function(event, jqxhr, settings, thrownError)
                                        {
                                        showSnack   (
                                                    'error',                                                    
                                                    (thrownError !== 'unknown status') ? thrownError : 'Request failed.'
                                                    );
                                        }
                                    );             



            var toastDefaultDelay = 4000;



            var showToast = function(type, title, subTitle, content)
                                {                                                          
                                return $.toast  (
                                                    {
                                                    type                : type ?? null,
                                                    title               : title ?? null,
                                                    subtitle            : subTitle ?? null,
                                                    content             : content ?? null,                                                
                                                    delay               : toastDefaultDelay                                                                   
                                                    }
                                                );                                                                            
                                }



            var showSnack = function(type, content)
                                {
                                return $.snack(type, content, toastDefaultDelay);
                                }



            var showMessage =  function(jqxhr) 
                                    {                                                                        
                                    var messages = jqxhr.responseJSON.messages;
                                    var messageArray = [];
                                    
                                    $('#ajax-messages').empty();

                                    if( typeof messages !==  'undefined')
                                        {
                                        if(typeof messages !== 'object')
                                            {
                                            messageArray.push(messages);
                                            }
                                            else    {
                                                    messageArray = messages;
                                                    }
                                                                                                                    
                                        $('#ajax-messages-wrapper').removeClass('d-none');
                                    

                                        $.each  (
                                                messageArray,
                                                function(k, v)
                                                    {
                                                    $('#ajax-messages').append('<div>' + v + '</div>');                                                                                            
                                                    }
                                                );
                                        }                                                                        
                                    }
            }
    );